/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useTranslation } from "react-i18next";
import { actions } from "../../store/reducers/authentication";
import ApplicationsLayout from "../../components/Layout/Applications";
import { Footer } from "../../components/Layout/Footer";
import CustomButton from "../../components/Button";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { getRedirectPath } from "../../constants/user";
import LoginComponent from '../Login';
import { useHeight } from "../../helpers/useHeight";
import Redirect from "../../components/Redirect";

const demo = process.env.REACT_APP_ENV === 'demo';

const Applications = ({
  authentication: { user },
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const redirectPath = user ? getRedirectPath(user, query && query.get('fallback') ? query.get('fallback') : '') : '';
  const { height } = useHeight();

  if (demo) {
    return <LoginComponent />;
  }

  return redirectPath ? <Redirect to={redirectPath} /> : (
    <div style={{ height }}>
      <ApplicationsLayout
        header={t('Simplify your work. Monetise your knowledge.')}
        headerTitle={t('New Here?')}
        linkText={t('Get Started')}
        linkHref="/register"
      >
        <div className="apps-cont">
          <div className="main-cont">
            <div className="apps-header">
              <h2>{t('Applications')}</h2>
              <p>{t('Knowledge management solutions currently available in the Datastake ecosystem.')}</p>
            </div>
            <div className="apps-cards">
              <div className="card">
                <div className="left">
                  <div className="flex-row img-c">
                    <div className="flex-1 flex flex-column justify-content-center">
                      <img src="/assets/images/applications/mmt-logo.svg" alt="mmt-logo" />
                    </div>
                    <div className="flex flex-column justify-content-center">
                      <div className="tag-c">
                        <div className="tag">
                          <div className="flex flex-column justify-content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                              <path d="M2.79169 4.77384V3.69051C2.79169 2.19474 4.00425 0.982178 5.50002 0.982178C6.61061 0.982178 7.56507 1.65065 7.983 2.60718M5.50002 7.21134V8.29468M3.76669 10.7322H7.23335C8.14344 10.7322 8.59848 10.7322 8.94609 10.5551C9.25185 10.3993 9.50044 10.1507 9.65624 9.84491C9.83335 9.4973 9.83335 9.04226 9.83335 8.13218V7.37384C9.83335 6.46376 9.83335 6.00872 9.65624 5.66111C9.50044 5.35535 9.25185 5.10675 8.94609 4.95096C8.59848 4.77384 8.14344 4.77384 7.23335 4.77384H3.76669C2.8566 4.77384 2.40156 4.77384 2.05395 4.95096C1.74819 5.10675 1.4996 5.35535 1.3438 5.66111C1.16669 6.00872 1.16669 6.46376 1.16669 7.37384V8.13218C1.16669 9.04226 1.16669 9.4973 1.3438 9.84491C1.4996 10.1507 1.74819 10.3993 2.05395 10.5551C2.40156 10.7322 2.8566 10.7322 3.76669 10.7322Z" stroke="#175CD3" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                          <span>{t('Public')}</span>
                        </div>

                      </div>
                    </div>
                  </div>
                  <h1>
                    {t('Public application for the mining & mineral trade sector')}
                  </h1>
                  <p>
                    {t('mmtDesc')}
                  </p>
                  <div className="buttons">
                    <Link to="/register">
                      <CustomButton className="blue-color">
                        {t('Sign Up')}
                      </CustomButton>
                    </Link>
                    <Link to="/login">
                      <CustomButton type="primary">
                        {t('Log In')}
                      </CustomButton>
                    </Link>
                  </div>
                  <div className="demo">
                    <span>
                      {t('Want to explore features?')}
                      {' '}
                      <a href={process.env.REACT_APP_DEMO_BASE_URL}>
                        {t('Try Demo')}</a>
                    </span>
                  </div>
                </div>
                <div className="right-c">
                  <img src="/assets/images/applications/mmt-prev.png" alt="mmt-prev" />
                </div>
              </div>

              <div className="card reverse">
                <div className="left">
                  <div className="flex-row img-c">
                    <div className="flex-1 flex flex-column justify-content-center">
                      <img src="/assets/images/applications/asm-icon.svg" alt="mmt-logo" />
                    </div>
                    <div className="flex flex-column justify-content-center">
                      <div className="tag-c">
                        <div className="tag private">
                          <div className="flex flex-column justify-content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                              <path d="M9.2082 5.77381V4.69048C9.2082 3.19471 7.99564 1.98215 6.49987 1.98215C5.0041 1.98215 3.79153 3.19471 3.79153 4.69048V5.77381M6.49987 8.21131V9.29465M4.76653 11.7321H8.2332C9.14329 11.7321 9.59833 11.7321 9.94593 11.555C10.2517 11.3992 10.5003 11.1506 10.6561 10.8449C10.8332 10.4973 10.8332 10.0422 10.8332 9.13215V8.37381C10.8332 7.46373 10.8332 7.00869 10.6561 6.66108C10.5003 6.35532 10.2517 6.10672 9.94593 5.95093C9.59833 5.77381 9.14329 5.77381 8.2332 5.77381H4.76653C3.85645 5.77381 3.40141 5.77381 3.0538 5.95093C2.74804 6.10672 2.49944 6.35532 2.34365 6.66108C2.16653 7.00869 2.16653 7.46373 2.16653 8.37381V9.13215C2.16653 10.0422 2.16653 10.4973 2.34365 10.8449C2.49944 11.1506 2.74804 11.3992 3.0538 11.555C3.40141 11.7321 3.85645 11.7321 4.76653 11.7321Z" stroke="#384250" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                          <span>{t('Private')}</span>
                        </div>

                      </div>
                    </div>
                  </div>
                  <h1>
                    {t("ARM's digital system to assess ASM operations against global standards")}
                  </h1>
                  <p>
                    {t('armDesc')}
                  </p>
                  <div className="buttons">
                    <a href="https://www.responsiblemines.org/en/2021/06/arm-betterchain-collaborate/" target="_blank" rel="noreferrer">
                      <CustomButton className="blue-color">
                        {t('Learn More')}
                      </CustomButton>
                    </a>
                    <a href="mailto:arm@responsiblemines.org" target="_blank" rel="noreferrer">
                      <CustomButton type="primary">
                        {t('Contact')}
                      </CustomButton>
                    </a>
                  </div>
                </div>
                <div className="right-c">
                  <img src="/assets/images/applications/arm-prev.png" alt="asm-prev" />
                </div>
              </div>

              <div className="card">
                <div className="left">
                  <div className="flex-row img-c">
                    <div className="flex-1 flex flex-column justify-content-center">
                      <img className="tif-logo" src="/assets/images/applications/tif-logo.svg" alt="mmt-logo" />
                    </div>
                    <div className="flex flex-column justify-content-center">
                      <div className="tag-c">
                        <div className="tag permissioned">
                          <div className="flex flex-column justify-content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                              <path d="M7.125 4.23212H7.13042M7.125 7.48212C8.91993 7.48212 10.375 6.02704 10.375 4.23212C10.375 2.43719 8.91993 0.982117 7.125 0.982117C5.33007 0.982117 3.875 2.43719 3.875 4.23212C3.875 4.38036 3.88492 4.52628 3.90415 4.66926C3.93576 4.90442 3.95157 5.022 3.94093 5.09639C3.92984 5.17389 3.91573 5.21565 3.87754 5.28398C3.84087 5.34958 3.77626 5.41419 3.64703 5.54342L0.878841 8.31161C0.785159 8.40529 0.738318 8.45213 0.70482 8.5068C0.675121 8.55526 0.653235 8.6081 0.639966 8.66337C0.625 8.7257 0.625 8.79195 0.625 8.92443V9.86545C0.625 10.1688 0.625 10.3205 0.684038 10.4364C0.73597 10.5383 0.818834 10.6211 0.920755 10.6731C1.03662 10.7321 1.1883 10.7321 1.49167 10.7321H2.43268C2.56517 10.7321 2.63141 10.7321 2.69375 10.7171C2.74902 10.7039 2.80186 10.682 2.85032 10.6523C2.90498 10.6188 2.95183 10.572 3.04551 10.4783L5.8137 7.71009C5.94293 7.58086 6.00754 7.51624 6.07314 7.47958C6.14147 7.44138 6.18323 7.42727 6.26072 7.41619C6.33511 7.40555 6.45269 7.42135 6.68785 7.45297C6.83083 7.47219 6.97676 7.48212 7.125 7.48212Z" stroke="#996F25" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                          <span>{t('Permissioned')}</span>
                        </div>

                      </div>
                    </div>
                  </div>
                  <h1>
                    {t('Information Management System for Sustainable Impact Financing')}
                  </h1>
                  <p>
                    {t('tifDesc')}
                  </p>
                  <div className="buttons">
                    <Link to="/tif/register">
                      <CustomButton className="blue-color">
                        {t('Sign Up')}
                      </CustomButton>
                    </Link>
                    <Link to="/tif/login">
                      <CustomButton type="primary">
                        {t('Log In')}
                      </CustomButton>
                    </Link>
                  </div>

                  <div className="demo">
                    <span>
                      {t('Want to learn more?')}
                      {' '}
                      <a target="_blank" href="https://www.theimpactfacility.com/about-us/contact-us/" rel="noreferrer">
                        {t('Contact TIF')}
                      </a>
                    </span>
                  </div>
                </div>
                <div className="right-c">
                  <img src="/assets/images/applications/tif-app.png" alt="mmt-prev" />
                </div>
              </div>

              {/* <div className="card reverse">
                <div className="left">
                  <div className="flex-row img-c">
                    <div className="flex-1 flex flex-column justify-content-center">
                      <img src="/assets/images/applications/tazama-logo.svg" className="tazama-logo" alt="mmt-logo" />
                    </div>
                    <div className="flex flex-column justify-content-center">
                      <div className="tag-c">
                        <div className="tag permissioned">
                          <div className="flex flex-column justify-content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                              <path d="M7.125 4.23212H7.13042M7.125 7.48212C8.91993 7.48212 10.375 6.02704 10.375 4.23212C10.375 2.43719 8.91993 0.982117 7.125 0.982117C5.33007 0.982117 3.875 2.43719 3.875 4.23212C3.875 4.38036 3.88492 4.52628 3.90415 4.66926C3.93576 4.90442 3.95157 5.022 3.94093 5.09639C3.92984 5.17389 3.91573 5.21565 3.87754 5.28398C3.84087 5.34958 3.77626 5.41419 3.64703 5.54342L0.878841 8.31161C0.785159 8.40529 0.738318 8.45213 0.70482 8.5068C0.675121 8.55526 0.653235 8.6081 0.639966 8.66337C0.625 8.7257 0.625 8.79195 0.625 8.92443V9.86545C0.625 10.1688 0.625 10.3205 0.684038 10.4364C0.73597 10.5383 0.818834 10.6211 0.920755 10.6731C1.03662 10.7321 1.1883 10.7321 1.49167 10.7321H2.43268C2.56517 10.7321 2.63141 10.7321 2.69375 10.7171C2.74902 10.7039 2.80186 10.682 2.85032 10.6523C2.90498 10.6188 2.95183 10.572 3.04551 10.4783L5.8137 7.71009C5.94293 7.58086 6.00754 7.51624 6.07314 7.47958C6.14147 7.44138 6.18323 7.42727 6.26072 7.41619C6.33511 7.40555 6.45269 7.42135 6.68785 7.45297C6.83083 7.47219 6.97676 7.48212 7.125 7.48212Z" stroke="#996F25" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                          <span>{t('Permissioned')}</span>
                        </div>

                      </div>
                    </div>
                  </div>
                  <h1>
                    {t("Locally-led, collaborative risk management ecosystem")}
                  </h1>
                  <p>
                    {t('tazamaDesc')}
                  </p>
                  <div className="buttons">
                    <Link to="/tazama/register">
                      <CustomButton className="blue-color">
                        {t('Sign Up')}
                      </CustomButton>
                    </Link>
                    <Link to="/tazama/login">
                      <CustomButton type="primary">
                        {t('Log In')}
                      </CustomButton>
                    </Link>
                  </div>

                  <div className="demo">
                    <span>
                      {t('Want to learn more?')}
                      {' '}
                      <a target="_blank" href="https://www.theimpactfacility.com/about-us/contact-us/" rel="noreferrer">
                        {t('Contact TAZAMA')}
                      </a>
                    </span>
                  </div>
                </div>
                <div className="right-c">
                  <img src="/assets/images/applications/arm-prev.png" alt="asm-prev" />
                </div>
              </div> */}
            </div>
          </div>
          <Footer />
        </div>
      </ApplicationsLayout>
    </div>
  )
};

const mstp = ({ authentication }) => ({ authentication });
export default connect(mstp, actions)(Applications);
